export const MuiLink = {
  button: {
    fontSize: 14,
  },
  root: {
    fontWeight: 600,
  },
}
